import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[workUiModal]',
  standalone: true,
})
export class ModalDirective {
  viewContainerRef = inject(ViewContainerRef);
}
